import * as React from "react";
import { Modal, Button, Tooltip } from "antd";
import ManagePartyForm from "../Form/ManagePartyForm";
import {
  EditOutlined,

  // CloseOutlined,
  // CheckOutlined,
} from "@ant-design/icons";

export const ManagePartyModalContext = React.createContext<{
  setIsModalVisible: (active: boolean) => void;
}>({
  setIsModalVisible: () => true,
});

const PartyManageModal: React.FC<{ id: number }> = ({ id }) => {
  const [isModalVisible, setIsModalVisible] = React.useState(false);

  const showModal = () => setIsModalVisible(true);

  const handleOk = () => setIsModalVisible(false);

  const handleCancel = () => setIsModalVisible(false);

  return (
    <ManagePartyModalContext.Provider value={{ setIsModalVisible }}>
      <Tooltip title="Edit/Update">
        <Button
          onClick={showModal}
          type="primary"
          shape="circle"
          icon={<EditOutlined />}
        />
      </Tooltip>
      <Modal
        title="Manage Party"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
      >
        <ManagePartyForm id={id} />
      </Modal>
    </ManagePartyModalContext.Provider>
  );
};

export default PartyManageModal;
